import React from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiCheck } from "react-icons/fi";
import { Link } from 'react-router-dom';
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import TabTwo from "../elements/tab/TabTwo";
import ContactOne from "../elements/contact/ContactOne";
import PortfolioList from "../elements/portfolio/PortfolioList";
import ServiceList from "../elements/service/ServiceList";
import BlogContent from "../elements/blog/BlogContent";
import Helmet from "../component/common/Helmet";

const SlideList = [
    {
        textPosition: 'text-left',
        category: 'Freelance digital designer',
        title: 'Hello, I’m <span>Fatima</span> Welcome to my World.',
        description: '',
        buttonText: 'Download My CV',
        buttonLink: ''
    }
]
const PortfolioLanding = () => {
    let title = 'About Me',
        description = 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered in some form, by injected humour, or randomised words which dont look even slightly believable. If you are going to use a passage of Lorem Ipsum,';
    const PostList = BlogContent.slice(0 , 3);
    return (
        <div>
            <Helmet pageTitle="Essens" />
            <HeaderThree homeLink="/" logo="symbol-dark" color="color-white"/>
            {/* Start Slider Area   */}
            {/*<div id="home" className="fix">*/}
            {/*    <div className="slider-wrapper">*/}
            {/*        /!* Start Single Slide *!/*/}
            {/*        {SlideList.map((value , index) => (*/}
            {/*            <div className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image bg_image--25" key={index}>*/}
            {/*                <div className="container">*/}
            {/*                    <div className="row">*/}
            {/*                        <div className="col-lg-12">*/}
            {/*                            <div className={`inner ${value.textPosition}`}>*/}
            {/*                                {value.category ? <span className="theme-color font-700">{value.category}</span> : ''}*/}
            {/*                                {value.title ? <h1 className="title theme-gradient" dangerouslySetInnerHTML={{__html: value.title}}></h1> : ''}*/}
            {/*                                {value.description ? <p className="description">{value.description}</p> : ''}*/}
            {/*                                {value.buttonText ? <div className="slide-btn mt--20"><a className="btn-default" href={`${value.buttonLink}`}>{value.buttonText}</a></div> : ''}*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        ))}*/}
            {/*        /!* End Single Slide *!/*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/* End Slider Area   */}

            {/* Start About Area */}
            <div id="home" className="fix">
                <div className="about-area ptb--100 bg_color--essens-vert-blanc-desc">
                    <div className="about-wrapper">
                        <div className="container pl-5 pr-5" style={{maxWidth: 'initial'}}>
                            <div className="row row--35">
                                <div className="col-lg-2">
                                </div>
                                <div className="col-lg-8">
                                    <div className="thumbnail" style={{position: 'relative'}}>
                                        <figure>
                                            <img className="w-100" src="/assets/images/about/ACCUEIL800.jpg" alt="About Images"/>
                                            <figcaption className="caption-vert">LE BIEN-ETRE NE SE DECRETE PAS, IL SE VIT.</figcaption>
                                        </figure>
                                        <img style={{position: 'absolute', bottom: '70px', left: '10px', zIndex: '1', borderRadius: '0'}} className="w-25" src="/assets/images/about/logo-transparent.png" alt="About Images"/>
                                    </div>
                                    {/*<p className="vert-fonce pt--75">Le bien-être n’est pas simplement un concept, c’est une philosophie de vie.</p>*/}
                                    {/*<p className="vert-fonce mt_dec--20">C’est un art de vivre qui vise à cultiver l’équilibre, la sérénité et l’épanouissement à chaque instant.</p>*/}
                                </div>
                                <div className="col-lg-2">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Start About Area */}
            <div id="concept" className="fix">
                <div className="about-area ptb--120 bg_color--essens3">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35">
                                <div className="col-lg-5 d-none d-lg-block">
                                    <div className="thumbnail">
                                        <img data-aos="zoom-in" className="w-100" src="/assets/images/about/CONCEPT500x665.jpg" alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <span className="subtitle-vert">Notre</span>
                                            <h2 className="title" style={{marginTop: '-30px'}}>CONCEPT</h2>
                                            <p className="description-noir mt_dec--10">Chez Essens nous faisons le pari que le bien-être est la clé d'une vie plus épanouie, d'un travail plus harmonieux et de relations plus sincères.<br />Nous croyons profondément que chaque individu mérite de se sentir bien, d'être en paix avec lui-même et avec les autres.</p>
                                            <p className="description-noir mt_dec--10">C'est pourquoi, nous vous accompagnons dans le conseil et l'organisation de vos événements bien-être sur- mesure. Nous vous invitons au travers de vos événements, à la détente, à la pleine conscience et à la reconnexion à soi.<br />Nous ciblons les entreprises, les groupes associatifs ou séniors, ou bien encore les particuliers.</p>
                                            <p className="description-noir mt_dec--10">Le bien-être est bien plus qu'une tendance, c'est une véritable nécessité pour un monde en perpétuelle accélération. Et c'est avec cette conviction que nous vous accompagnons pour que chaque instant de votre événement devienne un moment de paix intérieure et de joie partagée.</p>
                                            <p className="description-noir mt_dec--10">Nous souhaitons vous faire bénéficier de la qualité des prestations de nos intervenants professionnels en accord avec vos attentes et en parfaite harmonie avec nos valeurs.</p>
                                            <p className="vert-fonce mt_dec--10">Forte d'une expérience professionnelle de huit années en tourisme événementiel. J'assure en parallèle la présidence d'une association spécialisée dans la recherche du mieux-être dans le Val d'Oise(95).</p>
                                            <p className="vert-fonce mt_dec--10">J'ai constaté depuis quelques années, qu'une forte demande en matière de bien-être est recherchée dans beaucoup de milieux. Cependant la réponse apportée n'est malheureusement pas toujours de qualité, laissant un goût amer sur l'expérience.</p>
                                            <p className="vert-fonce mt_dec--10">C'est pourquoi et comme une évidence, j'ai crée ESSENS, une agence de conseils et de services pour l'organisation de vos évènements bien-être en Ile de France.</p>
                                            <p className="vert-fonce mt_dec--10">Pouvoir vous faire vivre des instants précieux prônant l'harmonie, la découverte de votre ESSENCE et la reconnexion à vos SENS: "ES-SENS", est ma principale motivation.</p>
                                            <p className="vert-fonce mt_dec--10">Sarah DAUTIER<br />Directrice</p>
                                            <div className="mt_dec--10" style={{textAlign: 'right'}}>
                                                <span className="subtitle-vert" style={{textAlign: 'right'}}>"Créer l'équilibre est la clé"</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* End About Area */}

            {/* Start About Area */}
            <div id="wellbeing" className="fix">
                <div className="about-area ptb--120 bg_color--essens-vert-blanc-droite">
                    <div className="about-wrapper" data-aos="fade-up">
                        <div className="container">
                            {/*<div className="row row--35">*/}
                            {/*    <div className="col-lg-5">*/}
                            {/*        <div className="thumbnail">*/}
                            {/*            <img className="w-100" src="/assets/images/about/about-7.jpg" alt="About Images"/>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div className="col-lg-7">*/}
                                    <div className="about-inner inner">
                                        <div className="section-title ml_lg--200">
                                            <h2 className="title" style={{marginBottom: '-20px'}}>LE BIEN-ETRE AU TRAVAIL</h2>
                                            <span className="subtitle-vert">Chiffres clés</span>
                                            <p className="vert-fonce">Selon l’INRS (Institut National de Recherche et de Sécurité), « la notion de bien-être au travail est un concept englobant, de portée plus large que les notions de santé physique et mentale.</p>
                                            <p className="vert-fonce mt_dec--10">Elle fait référence à un sentiment général de satisfaction et d’épanouissement dans et par le travail qui dépasse l’absence d’atteinte à la santé ». Avec la crise sanitaire, cette notion s’est renforcée et est devenue un enjeu majeur pour les entreprises : le contexte a en effet poussé les salariés français à se recentrer sur le bien-être, leur épanouissement personnel et la raison d’être de leur travail.</p>

                                            <div className="row">
                                                <div className="col-lg-8">
                                                    <p className="marron mb-1 fontWeight500">Quelques données chiffrées</p>
                                                    <ul style={{color: 'black'}}>
                                                        <li>Seuls 27 % des salaries français s’épanouissent au travail</li>
                                                        <li>63 % estiment que leur employeur est responsable de leur bien-être au travail</li>
                                                        <li>82 % des salariés en France pensent qu’il est important de trouver des entreprises qui se soucient du bien-être</li>
                                                        <li>Les employeurs qui accordent la priorité au bien-être plutôt qu’au profit ont 2 X plus de chances d’avoir des salariés épanouis</li>
                                                        <li>Seuls 39 % des salariés estiment que leur direction s’engage dans l’amélioration du bien-être</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="row mt-5">
                                                <div className="col-lg-4">
                                                </div>
                                                <div className="col-lg-8">
                                                    <p className="marron mb-1 fontWeight500">Les principales recommandations</p>
                                                    <ul style={{color: 'black'}}>
                                                        <li>Rechercher le bien-être des salariés pour améliorer la rétention et la productivité.</li>
                                                        <li>Comprendre ce qui influe sur le bien-être au travail : Les salariés épanouis sont plus susceptibles d’occuper un bon poste. Les aider à se sentir motivés, à faire confiance aux autres et à avoir un sentiment d’appartenance aura un impact significatif sur leur bien-être.</li>
                                                        <li>Mettre en avant le bien-être des salariés pour attirer les talents.</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <p className="marron mt-5 fontWeight500" style={{textAlign: 'center'}}>82 % des salariés en France pensent qu'il est important de trouver des entreprises qui se soucient du bien-être</p>
                                            <div style={{textAlign: 'center'}} class="d-none d-lg-block">
                                                <img src="/assets/images/about/camembert-rose.jpg" alt="About Images" />
                                            </div>

                                            <p className="description mt--20">Source : Rapport de Forrester Consulting, juillet 2023.</p>
                                        </div>
                                    </div>
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>

            <div id="offer" className="fix">
                <div className="about-area pt--80 bg_color--essens-bleu-rose-bleu">
                <h1 className="offres">OFFRES ENTREPRISES</h1>
                    {/*<div className="about-wrapper">*/}
                    {/*    <div className="container">*/}
                            <div className="row row--0">
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="star">
                                            <img src="/assets/images/portfolio/etoile_transp.png" alt="etoile"/>
                                        </div>
                                        <div className="title">Pause Reset</div>
                                     </div>
                                     <div className="line"></div>
                                     <p className="offre-blanc-centre">FORMULE INDIVIDUELLE</p>
                                     <p className="offre-blanc-centre">Déconnecter pour mieux revenir</p>
                                     <img src="/assets/images/portfolio/thumbnail.png" width={100} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                                     <p className="offre-blanc-centre mt--30">Objectifs :</p>
                                     <ul className="offre-blanc ml--20 mb--40">
                                        <li>Déconnexion</li>
                                        <li>Recharge</li>
                                        <li>Récupération rapide</li>
                                     </ul>
                                     <img src="/assets/images/portfolio/etoile_transp.png" width={50} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                                     <p className="offre-blanc-centre mt--30">"La pause bien-être qui fait vraiment la différence"</p>
                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="star">
                                            <img src="/assets/images/portfolio/etoile_bleue_transp.png" alt="etoile"/>
                                        </div>
                                        <div className="title">Creative Break</div>
                                    </div>
                                    <div className="line"></div>
                                    <p className="offre-blanc-centre">FORMULE ATELIERS CREATIFS</p>
                                    <p className="offre-blanc-centre">La cohésion par la créativité</p>
                                    <img src="/assets/images/portfolio/thumbnail.png" width={100} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                                    <p className="offre-blanc-centre mt--30">Objectifs :</p>
                                    <ul className="offre-blanc ml--20 mb--40">
                                        <li>Cohésion</li>
                                        <li>Détente</li>
                                        <li>Expression</li>
                                    </ul>
                                    <img src="/assets/images/portfolio/etoile_bleue_transp.png" width={50} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                                    <p className="offre-blanc-centre mt--30">"La créativité au service de la cohésion d'équipe"</p>
                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="star">
                                            <img src="/assets/images/portfolio/etoile_transp.png" alt="etoile"/>
                                        </div>
                                        <div className="title">FLow & Focus</div>
                                    </div>
                                    <div className="line"></div>
                                    <p className="offre-blanc-centre">FORMULE PERFORMANCE & QVCT</p>
                                    <p className="offre-blanc-centre">Le bien-être au service des résultats</p>
                                    <img src="/assets/images/portfolio/thumbnail.png" width={100} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                                    <p className="offre-blanc-centre mt--30">Objectifs :</p>
                                    <ul className="offre-blanc ml--20 mb--40">
                                        <li>Performance</li>
                                        <li>Transformation durable</li>
                                        <li>Energie</li>
                                    </ul>
                                    <img src="/assets/images/portfolio/etoile_transp.png" width={50} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                                    <p className="offre-blanc-centre mt--30">"Des solutions concrètes pour des enjeux réels en entreprise."</p>
                                </div>
                            </div>
                            <div className="row row--0 mt--30">
                                <div className="col-md-4">
                                     <img src="/assets/images/portfolio/massage_assis_6x4.png" alt="etoile"/>
                                </div>
                                <div className="col-md-4">
                                    <img src="/assets/images/portfolio/reunion_filles_6x4.png" alt="etoile"/>
                                </div>
                                <div className="col-md-4">
                                    <img src="/assets/images/portfolio/filles_yoga_6x4.png" alt="etoile"/>
                                </div>
                            </div>
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>

            <div id="offer-companies2" className="fix">
                <div className="about-area pt--80 bg_color--essens-bleu-rose-bleu">
                    <h1 className="offres">OFFRES ENTREPRISES</h1>
                    <div className="row row--0">
                        <div className="col-md-4">
                            <div className="card">
                                <div className="star">
                                    <img src="/assets/images/portfolio/etoile_transp.png" alt="etoile"/>
                                </div>
                                <div className="title">Pause Reset</div>
                             </div>
                             <div className="line"></div>
                             <p className="offre-blanc-centre">20 / 30 mins par employé<br />&nbsp;</p>
                             <img src="/assets/images/portfolio/thumbnail.png" width={100} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                             <p className="offre-blanc-centre mt--30">
                                Shiatsu<br />
                                Reflexologie plantaire<br />
                                Reflexologie intégrale<br />
                                Massage dos/visage<br />
                                Drainage lymphatique<br />
                                Auto massage<br />
                                Détente oculaire<br />
                                Respiration consciente<br />
                                Cohérence cardiaque<br />
                                ...
                             </p>
                             <img src="/assets/images/portfolio/etoile_transp.png" width={50} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="star">
                                    <img src="/assets/images/portfolio/etoile_bleue_transp.png" alt="etoile"/>
                                </div>
                                <div className="title">Creative Break</div>
                            </div>
                            <div className="line"></div>
                            <p className="offre-blanc-centre">45 mins - 1h clé en main<br />Groupe maxi 10 pers</p>
                            <img src="/assets/images/portfolio/thumbnail.png" width={100} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                            <p className="offre-blanc-centre mt--30">
                                Composition végétale<br />
                                DIY-Zéro déchet<br />
                                Up Cycling<br />
                                Aquarelle<br />
                                Récolte de miel<br />
                                Ecriture intuitive<br />
                                Bougies cire d’abeille<br />
                                Bee wrap<br />
                                Atelier maquillage<br />
                                ...
                            </p>
                            <img src="/assets/images/portfolio/etoile_bleue_transp.png" width={50} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="star">
                                    <img src="/assets/images/portfolio/etoile_transp.png" alt="etoile"/>
                                </div>
                                <div className="title">FLow & Focus</div>
                            </div>
                            <div className="line"></div>
                            <p className="offre-blanc-centre">1h à + (selon format)<br />Groupe maxi 15 pers</p>
                            <img src="/assets/images/portfolio/thumbnail.png" width={100} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                            <p className="offre-blanc-centre mt--30">
                                Bain sonore<br />
                                Yoga doux<br />
                                Yoga sur Chaise<br />
                                Pilates<br />
                                Hypnose<br />
                                Sophrologie<br />
                                Alimentation au travail<br />
                                Gestion du stress<br />
                                Booster la concentration<br />
                                ...
                            </p>
                            <img src="/assets/images/portfolio/etoile_transp.png" width={50} alt="etoile" style={{display: 'block', margin: 'auto'}} />
                        </div>
                    </div>
                    <div className="row row--0 mt--30">
                        <div className="col-md-4">
                             <img src="/assets/images/portfolio/massage_assis_6x4.png" alt="etoile"/>
                        </div>
                        <div className="col-md-4">
                            <img src="/assets/images/portfolio/reunion_filles_6x4.png" alt="etoile"/>
                        </div>
                        <div className="col-md-4">
                            <img src="/assets/images/portfolio/filles_yoga_6x4.png" alt="etoile"/>
                        </div>
                    </div>
                </div>
            </div>

            <div id="offer-companies3" className="fix bg_color--essens-bleu" style={{marginBottom: '-760px', marginTop: '-155px'}}>
                {/*<div className="row row--0">*/}
                    <div className="col-md-7 offres-big">
                        ET SI LE BIEN-ÊTRE DEVENAIT UN VÉRITABLE OUTIL DE PERFORMANCE DANS VOTRE ENTREPRISE ?
                    </div>
                {/*    <div className="col-md-6">*/}
                        <img src="/assets/images/portfolio/AFFICHE.png" alt="etoile" style={{float: 'right'}}/>

                {/*    </div>*/}
                {/*</div>*/}

                <div className="footer-bar">
                  <div className="footer-text" style={{fontWeight: 500, fontSize: '24px'}}>
                    eventsessens@gmail.com<br />
                    06.50.68.43.55<br /><br />
                    www.essens-events.fr
                  </div>
                </div>
                <div className="circle"></div>

                <img src="/assets/images/portfolio/contactez-nous.png" alt="etoile" width={500} style={{position: 'relative', bottom: '1050px', left: '80px'}}/>
            </div>


            <div id="offer-individuals" className="fix">
                <div className="about-area pt--120 bg_color--essens-rose-bleu-rose">
                    <h1 className="offres">OFFRES<br />GROUPE DE PARTICULIERS</h1>
                    <div className="row row--0">
                        <div className="col-md-6">
                            <div className="card2">
                                <div className="star">
                                    <img src="/assets/images/portfolio/etoile_bleue_transp.png" alt="etoile"/>
                                </div>
                                <div className="title">Evénements</div>
                             </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card2">
                                <div className="star">
                                    <img src="/assets/images/portfolio/etoile_bleue_transp.png" alt="etoile"/>
                                </div>
                                <div className="title">Evénements</div>
                            </div>
                        </div>
                    </div>
                    <img src="/assets/images/portfolio/thumbnail.png" className="mt--30 mb--30" width={100} alt="etoile" style={{display: 'block', marginLeft: 'auto', marginRight: 'auto'}} />

                    <div className="row row--0">
                        <div className="col-md-3" >
                            <img src="/assets/images/portfolio/ballons_transp.png" width={200} alt="etoile" style={{float: 'right'}} />
                        </div>
                        <div className="col-md-6">
                            <p className="offre-blanc-centre mt--30">
                                Anniversaires
                            </p>
                            <p className="offre-blanc-centre mt--30">
                                EVJF/EVJG
                            </p>
                            <p className="offre-blanc-centre mt--30">
                                (enterrement de vie de jeunes filles et garçons)
                            </p>
                            <p className="offre-blanc-centre mt--30">
                                Evenements associatifs
                            </p>
                            <p className="offre-blanc-centre mt--30">
                                Mamans débordées / Femmes actives
                            </p>
                            <p className="offre-blanc-centre mt--30">
                                Indépendants/Freelances/Entrepreneurs
                            </p>
                            <p className="offre-blanc-centre mt--30">
                                Etudiants/ Jeunes actifs
                            </p>
                        </div>
                        <div className="col-md-3">
                        </div>
                    </div>

                    <div className="row row--0 mt--30">
                        <div className="col-md-4">
                             <img src="/assets/images/portfolio/particulier1_6x4.png" alt="etoile"/>
                        </div>
                        <div className="col-md-4">
                            <img src="/assets/images/portfolio/particulier2_6x4.png" alt="etoile"/>
                        </div>
                        <div className="col-md-4">
                            <img src="/assets/images/portfolio/particulier3_6x4.png" alt="etoile"/>
                        </div>
                    </div>
                </div>
            </div>


            {/*<div id="offer" className="fix">*/}
            {/*    <div className="about-area ptb--120 bg_color--essens-rose-blanc">*/}
            {/*        <div className="about-wrapper">*/}
            {/*            <div className="container">*/}
            {/*                <div className="row row--35">*/}
            {/*                    <div className="col-lg-5">*/}
            {/*                    </div>*/}
            {/*                    <div className="col-lg-7">*/}
            {/*                        <div className="about-inner inner">*/}
            {/*                            <div className="section-title">*/}
            {/*                                <span className="subtitle-vert">Notre</span>*/}
            {/*                                <h2 className="title" style={{marginTop: '-30px'}}>OFFRE</h2>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="row row--35 mt--20">*/}
            {/*                    <div className="col-lg-5 d-none d-lg-block">*/}
            {/*                        <div className="thumbnail" style={{alignSelf: 'center'}}>*/}
            {/*                            <img data-aos="zoom-in" className="w-75" src="/assets/images/about/OFFRE1_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                            <img data-aos="zoom-in" className="w-75 mt--30" src="/assets/images/about/OFFRE2_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                            <img data-aos="zoom-in" className="w-75 mt--30" src="/assets/images/about/OFFRE3_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="col-lg-7 d-flex">*/}
            {/*                        <div className="about-inner inner" style={{alignSelf: 'center'}}>*/}
            {/*                            <div className="section-title">*/}
            {/*                                <p className="vert-fonce font-weight-bold">1. CHOISIR NOS SERVICES</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Amélioration de la performance</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Des études montrent qu'un bien-être accru chez les employés conduit à une meilleure productivité, moins d'absentéisme, et une ambiance de travail plus positive.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Réduction du stress et du burn-out</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Offrir un cadre propice à la gestion du stress permet de réduire les risques de burn-out et d’accroître la satisfaction au travail.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Cohésion d’équipe et collaboration</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Nos événements favorisent l’esprit d’équipe, renforcent la communication et l’entraide entre collègues, éléments clés d’un environnement de travail sain.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Engagement et fidélisation des talents</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Proposer des initiatives de bien-être montre à vos collaborateurs que vous vous souciez de leur santé, ce qui renforce leur engagement et fidélité à l’entreprise.</p>*/}
            
            {/*                                <p className="vert-fonce font-weight-bold">2. UNE APPROCHE UNIQUE ET PERSONNALISÉE</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Chaque demande est unique</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Nous mettons beaucoup de bienveillance et d'écoute dans nos échanges pour répondre au mieux à vos sollicitations.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Nous créons des événements bien-être entièrement sur mesure pour répondre à vos objectifs spécifiques.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Que ce soit pour une journée de relaxation, une série d’ateliers sur le développement personnel ou un programme complet sur le bien-être au travail, nous nous adaptons à vos besoins.</p>*/}
            
            {/*                                <p className="vert-fonce font-weight-bold">3. UNE RÉPONSE ADAPTÉE AUX BESOINS SPÉCIFIQUES DES ENTREPRISES-CCAS-GROUPES DE PARTICULIERS</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Nos offres sont pensées pour répondre aux besoins spécifiques des entreprises et Comités d’Entreprise, des CCAS, des groupes de séniors, ainsi qu’à des demandes isolées de groupes de particuliers.</p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div id="offer-companies" className="fix">*/}
            {/*	<div className="about-area ptb--120 bg_color--essens-blanc-marron">*/}
            {/*		<div className="about-wrapper">*/}
            {/*			<div className="container">*/}
            {/*				<div className="row row--35">*/}
            {/*					<div className="col-lg-5"></div>*/}
            {/*					<div className="col-lg-7">*/}
            {/*						<div className="about-inner inner">*/}
            {/*							<div className="section-title">*/}
            {/*								<span className="subtitle-vert">Offre</span>*/}
            {/*								<h2 className="title" style={{marginTop: '-30px'}}>ENTREPRISES</h2>*/}
            {/*							</div>*/}
            {/*						</div>*/}
            {/*					</div>*/}
            {/*				</div>*/}
            {/*				<div className="row row--35 mt--20">*/}
            {/*					<div className="col-lg-5 d-none d-lg-block">*/}
            {/*						<div className="thumbnail" style={{alignSelf: 'center'}}>*/}
            {/*							<img data-aos="zoom-in" className="w-75" src="/assets/images/about/OFFRE_ENTREPRISE1_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*							<img data-aos="zoom-in" className="w-75 mt--30" src="/assets/images/about/OFFRE_ENTREPRISE2_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*							<img data-aos="zoom-in" className="w-75 mt--30" src="/assets/images/about/OFFRE_ENTREPRISE3_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="col-lg-7 d-flex">*/}
            {/*                        <div className="about-inner inner" style={{alignSelf: 'center'}}>*/}
            {/*                            <div className="section-title">*/}
            {/*                                <p className="description-noir mt_dec--20">LE BIEN-ETRE EN ENTREPRISE : Un enjeu humain, social et économique</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Nos formats sont entièrement personnalisables et peuvent s'inspirer de l'ensemble de notre expertise.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Chaque événement est unique. Les prestations proposées peuvent inclure des activités issues de nos différentes offres : cercles de parole, yoga, ateliers créatifs, respirations consciente, danse collective et bien d'autres...</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">Toutes nos interventions sont modulables et adaptées au contexte professionnel dans le respect de vos objectifs et de votre cultuyre d'entreprise.</p>*/}

            {/*                                <p className="description-noir mt_dec--20">NOS PRESTATIONS</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Ateliers de gestion du stress et de relaxation</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Apprenez à vos employés à gérer leur stress efficacement grâce à des techniques de relaxation, de respiration et de méditation.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Séminaires de développement personnel</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Offrez à vos collaborateurs des formations sur des thèmes tels que la pleine conscience, la gestion du temps, l’intelligence émotionnelle, et bien d’autres compétences essentielles pour leur épanouissement personnel et professionnel.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Retraites bien-être pour les équipes</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Organisez des retraites immersives en pleine nature ou dans un cadre apaisant pour renforcer la cohésion d’équipe tout en favorisant le bien-être individuel.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Consulting personnalisé</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Nous vous accompagnons dans l’élaboration de stratégies de bien-être adaptées à la culture de votre entreprise : mise en place de programmes de bien-être au travail, création d’espaces de détente, etc.</p>*/}
            {/*                                <p className="vert-fonce mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Coaching collectif et individuel</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Nous proposons des séances de coaching pour renforcer les compétences émotionnelles et sociales de vos équipes, améliorer la communication et développer un leadership bienveillant.</p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div id="offer-senior" className="fix">*/}
            {/*    <div className="about-area ptb--120 bg_color--essens-blanc-vert">*/}
            {/*        <div className="about-wrapper">*/}
            {/*            <div className="container">*/}
            {/*                <div className="row row--35">*/}
            {/*                    <div className="col-lg-5"></div>*/}
            {/*                    <div className="col-lg-7">*/}
            {/*                        <div className="about-inner inner">*/}
            {/*                            <div className="section-title">*/}
            {/*                                <span className="subtitle-vert">Offre public</span>*/}
            {/*                                <h2 className="title" style={{marginTop: '-30px'}}>SENIORS / CCAS</h2>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="row row--35 mt--20">*/}
            {/*                    <div className="col-lg-5 d-none d-lg-block">*/}
            {/*                        <div className="thumbnail" style={{alignSelf: 'center'}}>*/}
            {/*                            <img data-aos="zoom-in" className="w-75" src="/assets/images/about/OFFRE_SENOR1_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                            <img data-aos="zoom-in" className="w-75 mt--30" src="/assets/images/about/OFFRE_SENOR2_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                            <img data-aos="zoom-in" className="w-75 mt--30" src="/assets/images/about/OFFRE_SENOR3_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="col-lg-7 d-flex">*/}
            {/*                        <div className="about-inner inner" style={{alignSelf: 'center'}}>*/}
            {/*                            <div className="section-title">*/}
            {/*                                <p className="description-noir mt_dec--20">LE BIEN ETRE : Une priorité pour les CCAS et les Associations</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    Nos objectifs :*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Sensibiliser à l'importance du bien-être dans les actions sociale : renforcement du lien social, lutte contre l’isolement et la précarité.</li>*/}
            {/*                                        <li>Proposer des événements bien-être pour les bénéficiaires des CCAS et des associations.</li>*/}
            {/*                                        <li>Montrer l'impact positif de ces événements sur la santé mentale, physique et sociale des participants.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="description-noir mt_dec--10">NOS PRESTATIONS</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Ateliers de relaxation et gestion du stress</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Méditation et pleine conscience : Séances de relaxation pour réduire le stress et améliorer l'état d'esprit.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Yoga doux ou stretching : Adapté aux personnes de tous âges et conditions physiques.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Respiration et relaxation guidée : Pour apprendre à gérer les émotions et le stress au quotidien.</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Activités physiques adaptées</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Gym douce : Séances adaptées aux personnes âgées ou fragiles.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Marche nordique ou randonnées : Promouvoir l'activité physique tout en renforçant le lien social.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Danse en groupe : Zumba, danse libre ou danse adaptée pour les seniors.</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Ateliers nutrition et bien-être</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Ateliers cuisine santé : Apprendre à cuisiner des repas simples, équilibrés et adaptés aux besoins des participants.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Conseils nutritionnels : Interventions d'experts afin de comprendre les bienfaits d'une alimentation saine.</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Ateliers créatifs et artistiques</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Peinture, dessin, ou sculpture : Favoriser l’expression de soi et la créativité pour booster la confiance en soi.</p>*/}
            {/*                                <p className="description-noir mt_dec--20">Art-thérapie : Utilisation de l’art pour favoriser l’expression des émotions et soulager les tensions.</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Séances d’accompagnement psychologique ou coaching de vie</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                                <p className="description-noir mt_dec--20">Ateliers de développement personnel : Techniques de gestion des émotions, de confiance en soi, etc.</p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div id="offer-individuals" className="fix">*/}
            {/*    <div className="about-area ptb--120 bg_color--essens-blanc-rose">*/}
            {/*        <div className="about-wrapper">*/}
            {/*            <div className="container">*/}
            {/*                <div className="row row--35">*/}
            {/*                    <div className="col-lg-5"></div>*/}
            {/*                    <div className="col-lg-7">*/}
            {/*                        <div className="about-inner inner">*/}
            {/*                            <div className="section-title">*/}
            {/*                                <span className="subtitle-vert">Offre</span>*/}
            {/*                                <h2 className="title" style={{marginTop: '-30px'}}>GROUPE DE PARTICULIERS</h2>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*                <div className="row row--35 mt--20">*/}
            {/*                    <div className="col-lg-5 d-none d-lg-block">*/}
            {/*                        <div className="thumbnail" style={{alignSelf: 'center'}}>*/}
            {/*                            <img data-aos="zoom-in" className="w-75" src="/assets/images/about/OFFRE_PARTICULIER1_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                            <img data-aos="zoom-in" className="w-75 mt--150" src="/assets/images/about/OFFRE_PARTICULIER2_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                            <img data-aos="zoom-in" className="w-75 mt--150" src="/assets/images/about/OFFRE_PARTICULIER3_500x500.jpg" alt="About Images" style={{borderRadius: '50%'}} />*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="col-lg-7 d-flex">*/}
            {/*                        <div className="about-inner inner" style={{alignSelf: 'center'}}>*/}
            {/*                            <div className="section-title">*/}
            {/*                                <p className="description-noir mt_dec--20">LE BIEN-ETRE EN GROUPE :<br />Une expérience partagée, un moment de détente et de convivialité.</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    Les bienfaits :*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Réduction du stress collectif</li>*/}
            {/*                                        <li>Augmentation de la productivité et de la créativité</li>*/}
            {/*                                        <li>Amélioration de la communication et de la confiance au sein du groupe</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">*/}
            {/*                                    Nos objectifs*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Sensibiliser à l’importance du bien-être collectif.</li>*/}
            {/*                                        <li>Proposer des idées d'événements bien-être adaptés aux groupes de particuliers.</li>*/}
            {/*                                        <li>Souligner les bienfaits de ces événements pour renforcer les liens et améliorer le bien-être personnel.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="description-noir mt_dec--10">NOS PRESTATIONS</p>*/}

            {/*                                <p className="vert-fonce mt_dec--10">Ateliers de relaxation et méditation</p>*/}
            {/*                                <p className="description-noir mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Méditation en groupe : Séances guidées pour favoriser le calme et la concentration.</li>*/}
            {/*                                        <li>Pleine conscience : Exercices pour apprendre à être présent et à vivre l’instant.</li>*/}
            {/*                                        <li>Respiration et relaxation : Techniques pour relâcher les tensions et améliorer la concentration.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="vert-fonce mt_dec--20">Activités physiques adaptées au groupe</p>*/}
            {/*                                <p className="description-noir mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Yoga en groupe : Séances de yoga douces, accessibles à tous, pour détendre le corps et l’esprit.</li>*/}
            {/*                                        <li>Stretching et relaxation musculaire : Des exercices simples pour dénouer les tensions accumulées.</li>*/}
            {/*                                        <li>Danse collective : Zumba, danse libre ou danses de groupe comme la danse folk ou la danse en ligne, pour se divertir ensemble et déstresser.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="vert-fonce mt_dec--20">Ateliers créatifs pour libérer la créativité</p>*/}
            {/*                                <p className="description-noir mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Peinture ou dessin collectif : Encourager l’expression créative tout en renforçant la cohésion.</li>*/}
            {/*                                        <li>Ateliers de DIY (Do It Yourself) : Créer des objets, des décorations ou des cadeaux ensemble.</li>*/}
            {/*                                        <li>Écriture collective : Écrire une histoire ou un poème en groupe, stimulant ainsi la coopération.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="vert-fonce mt_dec--20">Séances de bien-être et soins</p>*/}
            {/*                                <p className="description-noir mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Massage en groupe : Apprendre des techniques simples de massage à réaliser entre amis ou en famille.</li>*/}
            {/*                                        <li>Ateliers de soins naturels : Fabrication de cosmétiques maison ou de produits de soin.</li>*/}
            {/*                                        <li>Bains de vapeur ou sauna en groupe : Créer une atmosphère propice à la détente physique et mentale.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}

            {/*                                <p className="vert-fonce mt_dec--20">Ateliers de développement personnel et coaching de groupe</p>*/}
            {/*                                <p className="description-noir mt_dec--20">*/}
            {/*                                    <ul>*/}
            {/*                                        <li>Cercle de parole : Un moment pour échanger, écouter et partager des expériences de vie.</li>*/}
            {/*                                        <li>Coaching collectif : Des sessions de coaching pour travailler sur des objectifs personnels ou professionnels en groupe.</li>*/}
            {/*                                    </ul>*/}
            {/*                                </p>*/}
            {/*                            </div>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* Start COntact Area */}
            <div id="contact" className="fix">
                <div className="rn-contact-area pb--120 bg_color--essens-vert">
                    <ContactOne />
                </div>
            </div>
            {/* End COntact Area */}

            {/*<FooterTwo />*/}
            {/* Start Back To Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
            {/* End Back To Top */}
        </div>
    )
}

export default PortfolioLanding;
